export default __webpack_public_path__ + "static/media/Seguimiento_2.15e11618.svg";